module.exports = "<div class=\"banner bg-cover visible-xs\" _v-6c4b85de=\"\"></div><section class=pt0 _v-6c4b85de=\"\"><div class=container _v-6c4b85de=\"\"><div class=row _v-6c4b85de=\"\"><filter-table :tabs_url=tabs_url :url=url _v-6c4b85de=\"\"></filter-table></div></div></section>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6c4b85de!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/news/financial.vue
// module id = 377
// module chunks = 0